'use client'

import '../../components/eligibility/Eligibility.css'

import type { PropertyEligibilityProps } from '@/components/eligibility/PropertyEligibility'

import { Col, Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import { useIsMobile } from '@/hooks/useIsMobile'

const CardEligibility = ({
  steps = 1,
  title = 'Eligibility and requirements',
  subtext = 'Find out who can apply and what you’ll need to get started.',
  documentsTitle = '',
  documentsTitle2,
  documents = [],
  eligibilityTitle = 'Hi',
  yearsOld = 'years old',
  ageRange = {
    minimum: {
      value: '',
      label: 'Minimum Age'
    }
  },
  income = {
    range: 'RM 3,000 - RM 4,999',
    description: 'of minimum monthly gross income'
  }
}: PropertyEligibilityProps) => {
  const isTab = useIsMobile({ maxWidth: '992px' })

  return (
    <section id="card-eligibility" className="values section h-100">
      <Container>
        <Row className="mb-5 mx-auto text-center" style={{ color: 'var(--alrajhi-black)' }}>
          <h2 data-aos="fade-up" className="feature-title mb-0">
            {title}
          </h2>
          <span data-aos="fade-up">{subtext}</span>
        </Row>
        <Row className={`gy-4 align-items-stretch flex-row`}>
          {eligibilityTitle && (
            <Col
              xl={5}
              xs={12}
              className="eligibility-main-container"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <div className="docs-required-header text-center px-4 px-md-5">
                {eligibilityTitle}
              </div>
              <div
                className={`eligibilty-content ${
                  ageRange?.maximum?.value && 'justify-content-between'
                } pb-4 `}
              >
                <div className="eligibilty-age">
                  <div className="age_border">
                    <span className="purecounter">{ageRange?.minimum?.value}</span>
                    <span className="eligibility_age mx-2">{yearsOld}</span>
                  </div>
                  <div className="eligibility_age pt-2">{ageRange?.minimum?.label}</div>
                </div>
                {ageRange?.maximum?.value && (
                  <>
                    <div className="eligibilty-age middle">
                      <div className="table-desktop">
                        <span
                          style={{
                            borderBottomColor: '#231BFC',
                            borderBottomWidth: '6px',
                            borderBottomStyle: 'solid',
                            color: 'transparent'
                          }}
                        >
                          ,,,,,
                        </span>
                      </div>
                      <div></div>
                    </div>
                    <div className="eligibilty-age">
                      <div className="age_border">
                        <span className="purecounter">{ageRange.maximum.value}</span>
                        <span className="eligibility_age mx-2">{yearsOld}</span>
                      </div>
                      <div className="eligibility_age pt-2">{ageRange.maximum.label}</div>
                    </div>
                  </>
                )}
              </div>
              <div className="eligibilty-content-2">
                <div className="eligibilty-income">
                  {income?.subheading && (
                    <div className="eligibility_income">{income?.subheading}</div>
                  )}
                  <div>
                    <span
                      // style={{ fontSize: '48px' }}
                      className="special-range-font"
                    >
                      {income?.range}
                    </span>
                  </div>
                  {income?.description && (
                    <div className="eligibility_income">{income?.description}</div>
                  )}
                </div>
              </div>
            </Col>
          )}
          {documentsTitle && (
            <Col
              xl={steps === 2 ? 7 : 12}
              xs={12}
              className="d-flex justify-content-end flex-column required-documents"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="d-flex flex-wrap" data-aos="fade-right" data-aos-delay="200">
                {documentsTitle2 ? (
                  <div className="docs-required-header two-title">
                    <p
                      style={{
                        width: '35%',
                        display: isTab ? 'none' : 'block'
                      }}
                    >
                      {documentsTitle}
                    </p>
                    <p
                      style={{
                        width: isTab ? '100%' : '65%',
                        textAlign: isTab ? 'center' : 'left'
                      }}
                    >
                      {documentsTitle2}
                    </p>
                  </div>
                ) : (
                  <div className="docs-required-header">{documentsTitle}</div>
                )}
                <div className="docs-required-content d-flex align-items-center flex-column bottom-border">
                  {documents?.map(doc => (
                    <div
                      key={doc.title}
                      className={`row border-row ${eligibilityTitle && 'widthy'}`}
                    >
                      {doc?.title2 ? (
                        <div className="border-row-title color-alrajhi-brand">
                          {isTab ? parse(doc?.title2 ?? '') : parse(doc?.title ?? '')}
                        </div>
                      ) : (
                        <div className="border-row-title color-alrajhi-brand">
                          {parse(doc?.title ?? '')}
                        </div>
                      )}
                      {doc?.content && (
                        <div
                          className="border-row-content color-alrajhi-brand"
                          style={{
                            padding: '30px 16px',
                            lineHeight: '32px'
                          }}
                        >
                          {parse(doc?.content)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default CardEligibility
